var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("publicHeader"),
      _c("el-main", [
        _c(
          "div",
          { staticClass: "forgot" },
          [
            _c("h1", [_vm._v("再設定メールを送信しました")]),
            _c("p", [
              _vm._v(
                "一定時間経過してもメールが届かない場合は、再度お試しください。"
              ),
            ]),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.goSignIn } },
                  [_vm._v(_vm._s(_vm.$t("sign_in.back_signin")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }